import * as React from 'react';
import { getOnlyWeeksOf } from '@services/user/user.utils';
import {connect} from 'react-redux';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import Month from './Month';
import { weeksMonth } from '../helper';
import { IMonth, IDayData } from '../calendar.types';
import { MonthviewStyle } from './monthview.style';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import WeekInSmallView from './WeekInSmallView';
import { ILocalEvent } from '@app-types/websocket/event.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import { IExternalCalendar } from '@app-types/websocket/externalCalender.types';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  months: IMonth[];
  currentMonth:IMonth;
  isScrolling:boolean;
}

interface IProps extends WithStyles<typeof MonthviewStyle> {
  userId:number;
  inEditMode:boolean;
  reference:React.RefObject<HTMLDivElement>;
  focusDay:Date;
  schoolAge:number; 
  selectedEditDays:IDateRange[];
  highlight:IDateRange[];
  localEvents:ILocalEvent[];
  monthSize: "small"|"medium"|"large";
  isResizing:boolean;
  localization: "se"|"en";
  setCurrentMonth: (year:number,month:number) => void;
  setFocusDate: (year:number,month:number,date:number, position:"LEFT"|"RIGHT"|"NAN", isLongPress:boolean, originalDay?:Date) => void;
  swipeEditTransaction?: (action:"START"|"COMMIT") => void;
  swipeEdit?: (year:number,month:number,date:number, swipeDays:number, swipdeStartSide:"LEFT"|"RIGHT") => void;
  scheduleOne:ISchedule|undefined;
  scheduleTwo:ISchedule|undefined;
  scheduleThree:ISchedule|undefined;
  selectIDayInsteadOfMenuPop?: boolean;

  popMenu:(ref:HTMLDivElement|null) => void;
  setHeight:(height:number) => void

  fetchedEvents: { [day: string]: IExternalCalenderEvent[] }; 

  showWeekNumber:boolean;
  onlyWeeksOf:number|undefined;
  showActivitiesInEditMode:boolean;
}

class MonthView extends React.Component<IProps, IState> {
  private scrollTimer = setTimeout(() => {return;}, 100); // observing months onscroll and changing height of viewport if weeks = 5/6

  private observer: IntersectionObserver;
  private ignoreObserver = false;

  // --- speed-aware snap switching (no React state) ---------------------- // <<<
  private lastY = 0;
  private lastT = 0;
  private scrollIdleTimer: number | null = null;
  private flingThreshold = 1;        // px/ms; raise/lower to taste
  private nearSnapThreshold = 10;        // px to count as “at snap point”
  private snapMode: 'mandatory' | 'proximity' = 'mandatory';
  private isTouching = false;

  // ---------------------------------------------------------------------- // <<<

  constructor(props: IProps) {
    super(props);
    
    // create 48 months starting one year back
    const months:IMonth[] = [];
    let month = new Date().getUTCMonth();
    let year = new Date().getUTCFullYear() -1; // one year back
    for (let index = 0; index < 48; index++) {
      months.push(this.createMonth(year,month));
      if (month === 11) { month = 0; year = year +1;}
      else {month = month+1;}      
    }

    const thisMonth = this.createMonth(props.focusDay.getFullYear(), props.focusDay.getMonth());

    this.state = {
      currentMonth:thisMonth,
      months,
      isScrolling:false,
    };
  }
  
  public componentWillUnmount(): void {
    clearTimeout(this.scrollTimer);
    this.detachSpeedHandlers(); // <<< cleanup
  }

  public componentDidUpdate(prevProps:IProps, prevState:IState) {
    if (this.props.isResizing !== prevProps.isResizing) {
      if (this.props.isResizing) {
        if (this.observer) {
          this.observer.disconnect();
        }
        this.detachSpeedHandlers(); // <<<
      } else {
        this.scrollToCurrentMonth();
        this.attachSpeedHandlers(); // <<<
      }
    } else if (!this.props.isResizing && this.state.months !== prevState.months) {
      this.scrollToCurrentMonth();
    }
    if (this.props.inEditMode !== prevProps.inEditMode && this.props.inEditMode) {
      this.scrollToCurrentMonth();
    }
    if (this.props.monthSize !== prevProps.monthSize) {
      if (this.props.monthSize === 'small') {
        this.observer?.disconnect();
        this.detachSpeedHandlers(); // <<<
        this.setSnapType(''); // clear snap on container when not large
      } else {
        this.scrollToCurrentMonth();
        this.attachSpeedHandlers(); // <<<
      }
    }
  }

  public componentDidMount() {
    this.scrollToCurrentMonth();
    this.attachSpeedHandlers(); // <<<
  }

  public render() {
    const {classes, isResizing, monthSize, inEditMode, scheduleOne, scheduleTwo, 
      scheduleThree, highlight,selectedEditDays} = this.props;
    const {months, isScrolling, currentMonth} = this.state;

    const eventStyle:React.CSSProperties = {};

    // the chips' 11px line plus the padding: a fixed height keeps every lane of a week the same
    if (this.props.monthSize === "large") {
      eventStyle.padding = "3px 2px";
      eventStyle.height = "17px";
    } else {
      eventStyle.padding = "1px 2px";
      eventStyle.height = "13px";
    }

    if (isResizing) {

      return (<div className={classes.monthViewport} ref={this.props.reference} >
        <Month 
          importedEvents={this.props.localEvents}
          monthInView={currentMonth}
          isEditing={this.props.inEditMode}
          focusDay={this.props.focusDay}
          schoolAge={this.props.schoolAge}
          selectedEditDays={this.props.selectedEditDays}
          highlight={highlight}
          setFocusDate={this.props.setFocusDate}
          month={currentMonth} 
          scheduleOne={scheduleOne}
          scheduleTwo={scheduleTwo}
          scheduleThree={scheduleThree}
          selectIDayInsteadOfMenuPop={this.props.selectIDayInsteadOfMenuPop}
          localization={this.props.localization} 
          key={currentMonth.year+"-"+currentMonth.month}
          size={this.props.monthSize}
          isScrolling={isScrolling}
          hideEvents={false}
          externalEventsPerDay={this.props.fetchedEvents}
          popMenu={() => {return;}}
          showWeekNumber={this.props.showWeekNumber}
          onlyWeeksOf={this.props.inEditMode ? undefined : this.props.onlyWeeksOf}
          eventStyle={eventStyle}
        />
      </div>);
    }

    let myContent:JSX.Element[] = [];

    if (monthSize === "small") {
      myContent.push(
        <WeekInSmallView 
          isEditing={this.props.inEditMode}
          focusDay={this.props.focusDay}
          selectedEditDays={this.props.selectedEditDays}
          highlight={highlight}
          setFocusDate={this.props.setFocusDate}
          scheduleOne={scheduleOne}
          scheduleTwo={scheduleTwo}
          scheduleThree={scheduleThree}
          localization={this.props.localization} 
          key={"thisweek"}
          importedEvents={this.props.localEvents}
          size={this.props.monthSize}
          isScrolling={isScrolling}
          externalEventsPerDay={this.props.fetchedEvents}
          hideEvents={false}
          popMenu={this.props.popMenu}
          showWeekNumber={this.props.showWeekNumber}
          onlyWeeksOf={this.props.inEditMode ? undefined : this.props.onlyWeeksOf}

        />);
    } else {
      const hideEvents = inEditMode && !this.props.showActivitiesInEditMode;

      myContent = months.map((month) => <Month 
        importedEvents={this.props.localEvents}
        monthInView={this.state.currentMonth}
        isEditing={this.props.inEditMode}
        schoolAge={this.props.schoolAge}
        externalEventsPerDay={this.props.fetchedEvents}
        focusDay={this.props.focusDay}
        selectedEditDays={this.props.selectedEditDays}
        highlight={highlight}
        setFocusDate={this.props.setFocusDate}
        swipeEdit={this.props.swipeEdit}
        swipeEditTransaction={this.props.swipeEditTransaction}
        month={month} 
        selectIDayInsteadOfMenuPop={this.props.selectIDayInsteadOfMenuPop}
        scheduleOne={scheduleOne}
        scheduleTwo={scheduleTwo}
        scheduleThree={scheduleThree}
        localization={this.props.localization} 
        key={month.year+"-"+month.month}
        size={this.props.monthSize}
        isScrolling={isScrolling}
        hideEvents={hideEvents} 
        popMenu={this.props.popMenu}
        showWeekNumber={this.props.showWeekNumber}
        eventStyle={eventStyle}
        onlyWeeksOf={this.props.inEditMode ? undefined : this.props.onlyWeeksOf}
      />)
    }

    const erasedSchedule:boolean = scheduleOne !== undefined && scheduleOne.status === SCHEDULE_TYPES.DELETED;

    return (
      <div className={classes.monthViewport} 
        ref={this.props.reference}
        // NOTE: no inline scrollSnapType here; we set it directly on the element imperatively. // <<<
      >
        <div className={classes.erasedSchedule} style={erasedSchedule?{}:{display:'none'}}>{tn.lang.erased}</div>
        {myContent}
      </div>);
  }

  private scrollToCurrentMonth() {

    if (this.observer) {this.observer.disconnect();}
    this.ignoreObserver = true;

    const doScroll = () => {
      const container = this.props.reference.current;
      if (container) {
        let weeks = 0;
        let months = 0;
        for (const m of this.state.months) {
          if (m.month === this.state.currentMonth.month && m.year === this.state.currentMonth.year) {
            break;
          }
          weeks += m.weeksInMonth;
          months +=1;
        }
        
        if (this.props.monthSize === "small") {
          // not needed
        } else {

          const targetMonth = document.getElementById(`${this.state.currentMonth.year}-${this.state.currentMonth.month}`);
          if (targetMonth) {
            targetMonth.scrollIntoView({ behavior: 'auto', block: 'start' });
          } else {
            if (this.props.monthSize === "medium") {
              container.scrollTop = (weeks*40)+(months*10);
            } else if (this.props.monthSize === "large") {
              container.scrollTop = container.clientHeight*months;
            }  
          } 
        }
      }
      requestAnimationFrame(() => {
        this.observe();
        this.ignoreObserver = false;
      });
    }

    requestAnimationFrame(() => requestAnimationFrame(doScroll));
  }

  private createMonth(year:number, month:number):IMonth {
    const weeksInMonth =  weeksMonth(month,year,this.props.localization);
    const dayData:IDayData[] = [];
    const daysToPopulate = (new Date(year, month+1, 0,0,0,1)).getDate();

    let prevdayEnd:number = (new Date(year,month,1,0,0,0,0)).getTime();

    for (let index = 1; index <= daysToPopulate; index++) {

      const dayEnd:number = (new Date(year,month,index,24,0,0,0)).getTime();
      const data:IDayData = {
        year,
        month,
        date:index,
        startTime:prevdayEnd,
        endTime:(dayEnd -1),
      };
      dayData.push(data);
      prevdayEnd = dayEnd;
    }
    
    const monthData:IMonth = {year,month,weeksInMonth,dayData}
    return monthData;
  }

  private observe() {
    if (this.observer) {this.observer.disconnect();}

    const container = this.props.reference.current;

    if (container) {

      const options:IntersectionObserverInit = {
        root: container,
        rootMargin: "0px",
        threshold: 0.7,
      };

      const callback = (entries:IntersectionObserverEntry[], observer:IntersectionObserver) => {
        entries.forEach((entry:IntersectionObserverEntry) => {
          if (this.ignoreObserver || this.props.isResizing) {return;}
          if (entry.isIntersecting) {
            const visibleChildId = entry.target.getAttribute('id');
            if (visibleChildId) {              
              const yearMonth = visibleChildId.split("-");
              if (yearMonth.length === 2) {
                const year = parseInt(yearMonth[0],10);
                const month = parseInt(yearMonth[1],10);
                if (year > 2020 && year < 3000 && month >= 0 && month < 12) {
                  this.props.setCurrentMonth(year,month);
                  const currentMonth = this.state.months.find((m) =>m.month === month && m.year === year);
                  if (this.props.monthSize === "medium") {
                    setTimeout(() => {this.props.setHeight(entry.boundingClientRect.height-6)}, 200);
                  }
                  if (currentMonth) {
                    this.setState({currentMonth, isScrolling:true});
                    clearTimeout(this.scrollTimer);
                    this.scrollTimer = setTimeout(() => this.setState({isScrolling:false}), 4000);
                  }
                }
              }
            }
          }
        });
      };

      this.observer = new IntersectionObserver(callback, options);

      for (let index = 0; index < container.children.length; index++) {
        const element = container.children.item(index);
        if (element) {
          this.observer.observe(element);
        }
      }
    }
  }

  // =================== speed-aware snap switching (direct style writes) =================== // <<<

  private onScroll = () => {return;};
  private onPointerDown = () => {return;};
  private onPointerUp = () => {return;};
  private onTouchEnd = () => {return;};


  private attachSpeedHandlers() {
    const container = this.props.reference.current;
    if (!container || this.props.monthSize !== 'large') return;

    // default to mandatory on large view
    this.setSnapType('y mandatory');

    this.lastY = container.scrollTop;
    this.lastT = performance.now();
    

    this.onScroll = () => {
      const t = performance.now();
      const y = container.scrollTop;
      const dt = Math.max(1, t - this.lastT);
      const velocity = (y - this.lastY) / dt; // px/ms
      this.lastY = y;
      this.lastT = t;

      
      // If fling detected, enforce mandatory so we don't skip months
      if (this.isTouching) {
        // console.log('scroll' + velocity + this.snapMode);
        if (Math.abs(velocity) >= this.flingThreshold && this.snapMode !== 'mandatory') {
          this.setSnapType('y mandatory');
        } else if (Math.abs(velocity) < this.flingThreshold && this.snapMode !== 'proximity') {
          this.setSnapType('y proximity');
        }
      }
      

      // Debounce idle
      if (this.scrollIdleTimer) window.clearTimeout(this.scrollIdleTimer);
      this.scrollIdleTimer = window.setTimeout(() => this.onScrollIdle(), 140);
    };

    this.onPointerDown = () => {
      // while dragging: allow resting between months
      this.isTouching = true;
      if (this.snapMode !== 'proximity') this.setSnapType('y proximity');
    };
    this.onPointerUp = () => { this.isTouching = false;};
    this.onTouchEnd = this.onPointerUp;

    container.addEventListener('scroll', this.onScroll, { passive: true });
    container.addEventListener('pointerdown', this.onPointerDown, { passive: true });
    container.addEventListener('pointerup', this.onPointerUp, { passive: true });
    container.addEventListener('touchend', this.onTouchEnd, { passive: true });
  }

  private detachSpeedHandlers() {
    const container = this.props.reference.current;
    if (!container) return;
    container.removeEventListener('scroll', this.onScroll as any);
    container.removeEventListener('pointerdown', this.onPointerDown as any);
    container.removeEventListener('pointerup', this.onPointerUp as any);
    container.removeEventListener('touchend', this.onTouchEnd as any);
  }

  private onScrollIdle() {
    const container = this.props.reference.current;
    if (!container || this.props.monthSize !== 'large') return;

    // Only return to mandatory if we’re near a month boundary (prevents surprise jumps)
    const atSnap = this.distanceToNearestChildTop(container) <= this.nearSnapThreshold;
    if (atSnap && this.snapMode !== 'mandatory') {
      this.setSnapType('y mandatory');
    }
  }

  private setSnapType(value: '' | 'y mandatory' | 'y proximity') {
    const container = this.props.reference.current;
    if (!container) return;
    container.style.setProperty('scroll-snap-type', value);
    this.snapMode = value === 'y mandatory' ? 'mandatory'
                 : value === 'y proximity' ? 'proximity'
                 : this.snapMode;
  }

  private distanceToNearestChildTop(container: HTMLElement) {
    const y = container.scrollTop;
    let best = Infinity;
    for (const child of Array.from(container.children)) {
      const el = child as HTMLElement;
      const d = Math.abs(el.offsetTop - y);
      if (d < best) best = d;
    }
    return best;
  }
  // ======================================================================================== // <<<
}
  
function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const showActivitiesInEditMode:boolean = state.user.showActivitiesInEditMode?true:false;

  return {
    userId,
    onlyWeeksOf: getOnlyWeeksOf(state),
    showActivitiesInEditMode,
  };
}

export default connect(mapStateToProps)(withStyles(MonthviewStyle)(MonthView));



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/MonthView.tsx